/* eslint max-classes-per-file: 0 */

import {
  PublicationStorage as Data,
  PublicationStorageCollection as Collection,
} from '@/typings/api/Publication'

import { Fabric } from '@/store/createCrudModule'
import { PublicationStorageAdapter } from '@/views/Publications/Storage/store/PublicationStorageAdapter'
import { StorageAdapter } from '@/views/Publications/Storage/store/StorageAdapter'


export const fabric = Fabric<Data, Collection>()

type S = PublicationStorageState
type G = PublicationStorageGetters
type M = PublicationStorageMutations
type A = PublicationStorageActions


export class PublicationStorageState extends fabric.State {
}

export class PublicationStorageGetters extends fabric.Getters<S> {
}

export class PublicationStorageMutations extends fabric.Mutations<S> {
}

export class PublicationStorageActions extends fabric.Actions<S, G, M, A> {
    protected readonly adapter = new PublicationStorageAdapter();

    protected readonly storageAdapter = new StorageAdapter();

    protected readonly idName = 'id';

    public uploadFilesTimes({ storage_id, file } : {storage_id: Data['id']; file: File}) {
      return this.storageAdapter.api.updateFilesTimes(file, { storage_id })
    }
}
